<template>
  <div>
    <v-tooltip
      left
      color="primary"
    >
      <template #activator="{ on }">
        <v-btn
          icon
          v-on="on"
          @click="newEntry()"
        >
          <v-icon
            color="primary"
          >
            fal fa-plus-circle
          </v-icon>
        </v-btn>
      </template>
      <span>Add Help Topic</span>
    </v-tooltip>

    <!--Entry-->
    <v-dialog
      v-model="show"
      persistent
      scrollable
      max-width="900"
    >
      <v-card
        max-height="740"
        flat
      >
        <v-card-title class="text-h5 secondary--text">
          Help Topic Details<v-spacer /><v-btn
            text
            rounded
            outlined
            @click="cancelEntry()"
          >
            <v-icon
              small
              left
            >
              fal fa-times
            </v-icon>Cancel
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="entryForm"
            v-model="valid"
            lazy-validation
            @submit.prevent="saveEntry()"
          >
            <v-container fluid>
              <v-row dense>
                <!--Title-->
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    v-model="title"
                    label="Title"
                    placeholder=" "
                    required
                    :rules="rules.title"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    v-model="route"
                    label="Route"
                    placeholder=" "
                    required
                    :rules="rules.route"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <!--Text-->
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-textarea
                    v-model="text"
                    label="Text"
                    placeholder=" "
                    required
                    :rules="rules.text"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <!--User Type Type-->
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-autocomplete
                    v-model="flag_type"
                    :items="valueListsStore.userTypes"
                    label="User Type"
                    placeholder=" "
                    item-value="id"
                    item-text="value"
                    clearable
                    clear-icon="fal fa-times-circle"
                    required
                    :rules="rules.flag_type"
                  />
                </v-col>
              </v-row>

              <v-row
                v-if="mode !== 1"
                dense
              >
                <!--Status-->
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-autocomplete
                    v-model="flag_status"
                    :items="valueListsStore.activeStatus"
                    label="Status"
                    placeholder=" "
                    item-value="id"
                    item-text="value"
                    clearable
                    clear-icon="fal fa-times-circle"
                    required
                    :rules="flag_status === 0 ? [] : rules.flag_status"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="mx-4 pb-4">
          <v-btn
            block
            rounded
            color="primary"
            @click="saveEntry()"
          >
            <v-icon
              small
              left
            >
              fal fa-check
            </v-icon>Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'helpTopicsStore/getEntryField',
  mutationType: 'helpTopicsStore/updateEntryField',
});

export default {
  name: 'HelpTopic',
  data() {
    return {
      rules: {
        title: [
			    v => !!v || 'Required',
        ],
        route: [
			    v => !!v || 'Required',
        ],
        text: [
			    v => !!v || 'Required',
        ],
        flag_type: [
			    v => !!v || 'Required',
        ],
        flag_status: [
			    v => !!v || 'Required',
        ],
      },
    }
  },
  computed: {
    ...mapState({
      helpTopicsStore: state => state.helpTopicsStore,
      valueListsStore: state => state.valueListsStore,
    }),
    ...mapFields([
      'show',
      'valid',
      'mode',

      'id',
      'title',
      'route',
      'text',
      'flag_type',
      'flag_status'
    ]),
  },

  methods: {

    async newEntry() {
      this.$store.dispatch('helpTopicsStore/resetEntry');
      this.mode = 1;
      this.show = true;
    },

    cancelEntry() {
      this.show = false;
    },

    async saveEntry() {
      if (this.$refs.entryForm.validate()) {
        const entry = this.$store.getters['helpTopicsStore/getEntry'];
        /* Create */
        if (this.mode === 1) {
          await this.$store.dispatch('helpTopicsStore/create', entry);
        }
        /* Edit */
        else {
          await this.$store.dispatch('helpTopicsStore/update', entry);
        }
        this.cancelEntry();
      }
    },
  },
};
</script>

<style scoped>
  .clickable{
    cursor:pointer;
  }
  button {
    outline: none;
  }
</style>
